import classNames from 'classnames';
import React from 'react';

import css from './IconMapMarker.module.css';

const IconMapMarker = props => {
  const { className, rootClassName, width = 32 } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
    <svg
      className={classes}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      version="1.1"
      id="Layer_1"
      x="0px"
      y="0px"
      width={width}
      viewBox="0 0 1190.6 1190.6"
      xmlSpace="preserve"
    >
      <g>
        <path d="M594.4,67.1 M594.4,56.9C297,56.9,55.8,298,55.8,595.5s241.1,538.6,538.6,538.6S1133,893,1133,595.5   S891.9,56.9,594.4,56.9L594.4,56.9z" />
        <g>
          <polygon points="424.4,236.4 409.6,251.2 641.8,595.5 409.6,939.9 424.3,954.6 863,600.9 863,592   " />
        </g>
      </g>
    </svg>
  );
};

export default IconMapMarker;
